import {isPaidQueryParam} from "../queryParams";

export function paidParamsFrom(searchParams?: URLSearchParams): URLSearchParams {
    if (!searchParams) {
        return new URLSearchParams();
    }

    const filteredParamEntries = Array.from(searchParams?.entries())
        .filter(([queryParam]) => isPaidQueryParam(queryParam));

    return new URLSearchParams(Object.fromEntries(filteredParamEntries));
}